import { weddingStories } from '@/mocks/weddingStories'

export interface Crumb {
  name: string
  path: string
}

const STATIC_CRUMBS: Record<string, string> = {
  '/about': 'About',
  '/services': 'Services',
  '/wedding': 'Wedding',
  '/printing': 'Printing',
  '/gallery': 'Gallery',
  '/contact': 'Contact',
}

export function getBreadcrumbTrail(pathname: string): Crumb[] {
  const clean = pathname.replace(/\/+$/, '') || '/'
  const home: Crumb = { name: 'Home', path: '/' }

  if (clean === '/') return [home]

  if (STATIC_CRUMBS[clean]) {
    return [home, { name: STATIC_CRUMBS[clean], path: clean }]
  }

  if (clean === '/wedding-stories') {
    return [home, { name: 'Wedding', path: '/wedding' }, { name: 'Real Wedding Stories', path: '/wedding-stories' }]
  }

  if (clean.startsWith('/wedding-stories/')) {
    const slug = clean.split('/')[2]
    const story = weddingStories.find((item) => item.slug === slug)
    return [
      home,
      { name: 'Wedding', path: '/wedding' },
      { name: 'Real Wedding Stories', path: '/wedding-stories' },
      { name: story ? story.couple : 'Wedding Story', path: clean },
    ]
  }

  const last = clean.split('/').filter(Boolean).pop() || 'Page'
  const name = last.replace(/-/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase())
  return [home, { name, path: clean }]
}